var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"card-border",attrs:{"shaped":true}},[_c('v-card-title',[_vm._v("Total Leads Atrasados")]),_c('v-card-subtitle',[_vm._v(_vm._s(_vm.total))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }